import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm$inboundDelivery$c, _vm$inboundDelivery$c2, _vm$inboundDelivery$s, _vm$inboundDelivery$c3, _vm$inboundDelivery, _vm$inboundDelivery2;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "inbound-delivery-top-buttons"
  }, [[!_vm.isDocumentsFetched ? [_c(VBtn, {
    class: ["dfwa-btn", "--small"],
    attrs: {
      loading: _vm.isLoadingDocuments,
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.fetchDocuments();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      left: "",
      small: "",
      dark: ""
    }
  }, [_vm._v("fas fa-sync")]), _vm._v(" Documents ")], 1)] : [_c(VDialog, {
    attrs: {
      scrollable: "",
      width: "40rem"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          staticClass: "dfwa-btn --small",
          attrs: {
            disabled: !_vm.documents.length,
            rounded: true
          }
        }, "v-btn", attrs, false), on), [_vm._v(" Documents (" + _vm._s(_vm.documentCount) + ") ")])];
      }
    }]),
    model: {
      value: _vm.documentDialog,
      callback: function callback($$v) {
        _vm.documentDialog = $$v;
      },
      expression: "documentDialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        _vm.documentDialog = false;
      }
    }
  })], 1), _c(VCardTitle, [_vm._v("Documents")]), _c(VCardText, [_c(VTreeview, {
    attrs: {
      items: _vm.documents,
      "open-on-click": "",
      "item-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn(_ref2) {
        var item = _ref2.item,
          open = _ref2.open;
        return [!item.url ? _c("div", {
          staticClass: "d-flex align-center"
        }, [_c(VIcon, [_vm._v(" " + _vm._s(open ? "mdi-folder-open" : "mdi-folder") + " ")]), _c("span", [_vm._v(_vm._s(item.name) + " (" + _vm._s(item.children.length) + ")")])], 1) : _c("div", {
          on: {
            click: function click($event) {
              return _vm.openDocument(item);
            }
          }
        }, [_c("a", [_vm._v(_vm._s(item.name))])])];
      }
    }])
  })], 1)], 1)], 1)]], _vm.canManageInboundDelivery ? [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openAttachedFilesDrawer();
      }
    }
  }, [_vm._v(" Attached files ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openSendMailModal();
      }
    }
  }, [_vm._v(" Send mail ")]), _c("Comment", {
    attrs: {
      inboundDeliveryId: _vm.inboundDelivery.id,
      btnClassSupp: "secondary --small"
    }
  })] : _vm._e()], 2), _c("div", {
    staticClass: "container-centered small text-left"
  }, [_c("div", {
    staticClass: "inbound-delivery-maincontent"
  }, [_c("div", {
    staticClass: "inbound-delivery-maincontent-data"
  }, [_c("h3", [_vm._v("Order dispatch information")]), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-top --one-column"
  }, [_c("div", {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.inboundDelivery.reference) + " ")])]), _c("div", [_c("div", [_vm._m(0), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value",
    attrs: {
      "data-cy": "inbound-delivery-status-read"
    }
  }, [_vm._v(" " + _vm._s(_vm.inboundDeliveryStatus.filter(function (os) {
    return os.status === _vm.inboundDelivery.status;
  })[0].value) + " "), _c("span", {
    staticClass: "text-smaller"
  }, [_vm._v(" (" + _vm._s(_vm._f("formatDate")(_vm.inboundDelivery.lastStatusUpdateDate)) + ") ")])])]), _c("div", [_vm._m(1), _c("div", {
    staticClass: "text-sm"
  }, [_vm.inboundDelivery.validatedAt ? _c("div", [_vm._v(" Order : " + _vm._s(_vm._f("formatDate")(_vm.inboundDelivery.validatedAt)) + " ")]) : _vm._e(), _vm.inboundDelivery.approvedAt ? _c("div", [_vm._v(" Approved : " + _vm._s(_vm._f("formatDate")(_vm.inboundDelivery.approvedAt)) + " ")]) : _vm._e(), _vm.isShipped ? _c("div", [_vm._v(" Shipment : " + _vm._s(_vm._f("formatDate")(_vm.inboundDelivery.shipmentDate)) + " ")]) : _vm._e(), _vm.isDelivered ? _c("div", [_vm._v(" Delivered : " + _vm._s(_vm._f("formatDate")(_vm.inboundDelivery.deliveredAt)) + " ")]) : _vm._e(), _vm.inboundDelivery.paymentDate && _vm.inboundDelivery.paymentState === _vm.paymentState.SUCCEEDED ? _c("div", [_vm._v(" Payment : " + _vm._s(_vm._f("formatDate")(_vm.inboundDelivery.paymentDate)) + " ")]) : _vm._e()])])]), _c("div", [_c("div", [_vm._m(2), _c("div", {
    class: ["inbound-delivery-maincontent-data-value", _vm.canManageUsers ? "text-underline" : ""]
  }, [_vm.canManageUsers ? _c("router-link", {
    attrs: {
      to: _vm.goToUserEdit(_vm.inboundDelivery.user)
    }
  }, [_c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.userData)
    }
  })]) : _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.userData)
    }
  })], 1)]), _c("div", [_vm._m(3), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_c("div", [_vm._v(_vm._s(_vm.inboundDelivery.user.phone))]), _c("div", [_vm._v(_vm._s(_vm.inboundDelivery.user.login))]), _vm.inboundDelivery.user.contactEmail ? _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" Contact: " + _vm._s(_vm.inboundDelivery.user.contactEmail) + " ")]) : _vm._e(), _vm.inboundDelivery.user.billingEmail ? _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" Bill: " + _vm._s(_vm.inboundDelivery.user.billingEmail) + " ")]) : _vm._e()])])]), _c("div", [_c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-layer-group"
  }), _vm._v(" From order(s) "), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_vm.isFetchingOriginalOrders ? _c(VSkeletonLoader, {
    attrs: {
      type: "image",
      height: "2rem",
      width: "60%"
    }
  }) : _vm._e(), _vm._l(_vm.fromOrders, function (fromOrder, index) {
    var _fromOrder$invoiceNum;
    return [index < 5 || _vm.showAllOriginalOrders ? _c("div", {
      key: fromOrder.orderId
    }, [_c("i", {
      staticClass: "fas fa-link"
    }), _c("router-link", {
      staticClass: "router-link ml-2",
      attrs: {
        to: _vm.getOrderDetailsLink(fromOrder.orderId),
        target: "_blank"
      }
    }, [((_fromOrder$invoiceNum = fromOrder.invoiceNumberLabel) === null || _fromOrder$invoiceNum === void 0 ? void 0 : _fromOrder$invoiceNum.length) > 0 ? [_vm._v(" " + _vm._s(fromOrder.invoiceNumberLabel) + " "), _c("span", {
      staticClass: "text-smaller"
    }, [_vm._v("(" + _vm._s(fromOrder.reference) + ")")])] : [_vm._v(" " + _vm._s(fromOrder.reference) + " ")], _vm._v(" , " + _vm._s(_vm._f("formatDate")(fromOrder.createdAt)) + ", " + _vm._s(_vm.orderStatus.find(function (x) {
      return x.status === fromOrder.status;
    }).shortValue) + " ")], 2)], 1) : _vm._e()];
  }), _vm.fromOrders.length > 5 ? [!_vm.showAllOriginalOrders ? _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-3 secondary",
    on: {
      click: function click($event) {
        _vm.showAllOriginalOrders = true;
      }
    }
  }, [_vm._v(" +" + _vm._s("".concat(_vm.fromOrders.length - 5, " other").concat(_vm.fromOrders.length - 5 > 1 ? "s" : "")) + " ")])], 1) : _vm._e()] : _vm._e()], 2)])]), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value bold withBeforeSeparator"
  }, [_vm._v(" Payments ")]), _c("div", [_c("div", [_vm._m(4), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_vm.listTerms.find(function (pt) {
    return pt.id == _vm.inboundDelivery.buyerTerm;
  }) ? _c("div", [_vm._v(" " + _vm._s(_vm.listTerms.find(function (pt) {
    return pt.id == _vm.inboundDelivery.buyerTerm;
  }).name) + " ")]) : _c("div", [_vm._v("Undefined")]), _vm.textDueDate ? _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(_vm._s(_vm.textDueDate))]) : _vm._e()])])]), !_vm.isCancelled ? _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value --one-column",
    staticStyle: {
      "margin-top": "-1rem"
    }
  }, [!_vm.isCancelled ? _c("InboundDeliveryPaymentList", {
    key: _vm.inboundDelivery.status,
    ref: "inboundDeliveryPaymentList",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      inboundDelivery: _vm.inboundDelivery,
      fromOrders: _vm.fromOrders
    },
    on: {
      updateInboundDelivery: _vm.updateInboundWhenPaymentUpdated
    }
  }) : _vm._e()], 1) : _vm._e(), _c("div", {
    staticClass: "--one-column"
  }, [_c("div", {
    staticClass: "inbound-delivery-maincontent-data-total"
  }, [_c("div", {
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c("div", [_vm._v(" Balance due : " + _vm._s(_vm.formatPrice(_vm.remainingPaymentAmount)) + " " + _vm._s(_vm.getSymbolCurrency()) + " ")]), _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.inboundDelivery.totalAmountCurrencyIncludeShipping)) + " " + _vm._s(_vm.getSymbolCurrency()) + " ")])])])]), !!_vm.inboundDelivery.warehouse.name ? _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value bold withBeforeSeparator"
  }, [_vm._v(" Departure from " + _vm._s(_vm.inboundDelivery.warehouse.name) + " ")]) : _vm._e(), _vm.inboundDelivery.shipmentDate || _vm.inboundDelivery.trackingNumber ? _c("div", {
    staticClass: "inbound-delivery-maincontent-data-shippingdata"
  }, [_vm.inboundDelivery.shipmentDate ? _c("div", [_vm._m(5), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_vm._v(" " + _vm._s(new Intl.DateTimeFormat("en-GB", {
    dateStyle: "full"
  }).format(new Date(_vm.inboundDelivery.shipmentDate))) + " ")])]) : _vm._e(), _c("div", [_c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-barcode"
  }), _vm._v(" Tracking "), _vm.isTrackingEditable ? _c(VTooltip, {
    attrs: {
      top: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c("span", _vm._g(_vm._b({
          staticClass: "text-smaller",
          staticStyle: {
            cursor: "pointer"
          },
          attrs: {
            "data-cy": "tracking-edit-button"
          },
          on: {
            click: function click($event) {
              return _vm.startEditTracking();
            }
          }
        }, "span", attrs, false), on), [_vm._v(" ( "), _c("i", {
          staticClass: "fas fa-pen"
        }), _vm._v(" Edit ) ")])];
      }
    }], null, false, 1542806885)
  }, [_c("span", [_vm._v("Click to edit")])]) : _vm._e()], 1), !_vm.isEditingTracking ? [_vm.isUpdatingTracking ? _c(VSkeletonLoader, {
    attrs: {
      type: "list-item",
      width: "60%"
    }
  }) : _c("div", [_c("div", {
    staticClass: "inbound-delivery-maincontent-data-value",
    attrs: {
      "data-cy": "tracking-read-container"
    }
  }, [_vm.inboundDelivery.trackingUrl ? _c("div", [_c("i", {
    staticClass: "fas fa-external-link-alt mr-1"
  }), _c("a", {
    attrs: {
      target: "_blank",
      href: _vm.inboundDelivery.trackingUrl,
      "data-cy": "tracking-number-read-link"
    }
  }, [_vm._v(" " + _vm._s(_vm.inboundDelivery.trackingNumber ? "#" + _vm.inboundDelivery.trackingNumber.toUpperCase() : "No tracking number") + " ")])]) : _c("div", {
    attrs: {
      "data-cy": "tracking-number-read"
    }
  }, [_vm._v(" " + _vm._s(_vm.inboundDelivery.trackingNumber ? "#" + _vm.inboundDelivery.trackingNumber.toUpperCase() : "No tracking number") + " ")])])])] : _vm._e(), _vm.isEditingTracking ? [_c("div", {
    staticClass: "editing-tracking-container"
  }, [_c(VForm, {
    on: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.trackingForm.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "valid", $$v);
      },
      expression: "trackingForm.valid"
    }
  }, [_c(VTextField, {
    attrs: {
      placeholder: "Write tracking number",
      label: "Tracking number",
      "hide-details": "auto",
      "data-cy": "tracking-number-edit-input"
    },
    on: {
      input: function input($event) {
        _vm.trackingForm.inputTrackingNumber = _vm.trackingForm.inputTrackingNumber.trim();
      }
    },
    model: {
      value: _vm.trackingForm.inputTrackingNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "inputTrackingNumber", $$v);
      },
      expression: "trackingForm.inputTrackingNumber"
    }
  }), _c(VTextarea, {
    ref: "inputTrackingUrl",
    attrs: {
      rows: "3",
      label: "Tracking url",
      placeholder: "Write tracking url",
      "hide-details": "auto",
      "data-cy": "tracking-url-edit-input",
      rules: [_vm.rules.mustBeHttpLinkOrEmpty]
    },
    on: {
      input: function input($event) {
        _vm.trackingForm.inputTrackingUrl = _vm.trackingForm.inputTrackingUrl.trim();
      }
    },
    model: {
      value: _vm.trackingForm.inputTrackingUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "inputTrackingUrl", $$v);
      },
      expression: "trackingForm.inputTrackingUrl"
    }
  }), _c("div", [_c(VBtn, {
    staticClass: "ma-auto grey lighten-2",
    attrs: {
      text: "",
      "data-cy": "tracking-edit-save-button",
      disabled: !_vm.trackingForm.valid
    },
    on: {
      click: function click($event) {
        return _vm.updateTracking();
      }
    }
  }, [_vm._v(" Save ")]), _c(VBtn, {
    staticClass: "ma-auto",
    attrs: {
      text: "",
      "data-cy": "tracking-edit-cancel-button"
    },
    on: {
      click: function click($event) {
        return _vm.cancelTracking();
      }
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)], 1)] : _vm._e()], 2), _vm.inboundDelivery.shippedAt ? _c("div", {
    staticClass: "inbound-delivery-maincontent-data-shippingdata"
  }, [(_vm$inboundDelivery$c = _vm.inboundDelivery.carrier) !== null && _vm$inboundDelivery$c !== void 0 && _vm$inboundDelivery$c.name ? _c("div", [_vm._m(6), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_vm._v(" " + _vm._s(_vm.inboundDelivery.carrier.name) + " ")])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-address"
  }, [_c("div", [_c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked"
  }), _vm._v(" Delivery address "), !_vm.isShipped && !_vm.isCancelled && !_vm.isEditingAddresses ? _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    attrs: {
      title: "Edit addresses"
    },
    on: {
      click: function click($event) {
        return _vm.editAddresses();
      }
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_c("Address", {
    ref: "deliveryAddress",
    attrs: {
      baseModel: _vm.inboundDelivery.deliveryAddress,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: !_vm.isEditingAddresses,
      disabledCountry: true,
      disabledState: true,
      countryTooltipMessage: "You cannot change the country of delivery at this stage because some of the wines in your cart are only available in this country."
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    }
  })], 1)]), _c("div", [_c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v(" Billing address "), !_vm.isShipped && !_vm.isCancelled && !_vm.isEditingAddresses ? _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    attrs: {
      title: "Edit addresses"
    },
    on: {
      click: function click($event) {
        return _vm.editAddresses();
      }
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_vm.sameAddress == false ? _c("Address", {
    ref: "billingAddress",
    attrs: {
      baseModel: _vm.inboundDelivery.billingAddress,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    }
  }) : _vm._e(), !_vm.isShipped && _vm.sameAddress ? _c("div", [_c(VCheckbox, {
    attrs: {
      id: "sameAddress",
      label: "Billing address is identical",
      readonly: !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    },
    model: {
      value: _vm.sameAddress,
      callback: function callback($$v) {
        _vm.sameAddress = $$v;
      },
      expression: "sameAddress"
    }
  })], 1) : _vm._e()], 1), !_vm.isShipped && !_vm.sameAddress ? _c("div", [_c(VCheckbox, {
    attrs: {
      id: "sameAddress",
      label: "Billing address is identical",
      readonly: !_vm.isEditingAddresses,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    },
    model: {
      value: _vm.sameAddress,
      callback: function callback($$v) {
        _vm.sameAddress = $$v;
      },
      expression: "sameAddress"
    }
  })], 1) : _vm._e()]), !_vm.isShipped && !_vm.isCancelled && _vm.isEditingAddresses ? _c("div", {
    staticClass: "--one-column",
    staticStyle: {
      "margin-top": "-0.4rem"
    }
  }, [_c("div", {
    staticClass: "flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: true,
      disabled: _vm.isSavingAddresses
    },
    on: {
      click: function click($event) {
        return _vm.cancelAddresses();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _vm.isEditingAddresses ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2 highlight",
    attrs: {
      rounded: true,
      loading: _vm.isSavingAddresses
    },
    on: {
      click: _vm.saveAddress
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save delivery and billing addresses ")], 1) : _vm._e()], 1)]) : _vm._e()]), _c("div", [_c("div", {
    staticClass: "delivery-instructions"
  }, [_c("div", [_c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck-loading"
  }), _vm._v(" Delivery instructions "), _vm.deliveryInstructionsEditable && !_vm.isEditingDeliveryInstructions ? _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    on: {
      click: function click($event) {
        return _vm.startEditDeliveryInstructions();
      }
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [!_vm.isEditingDeliveryInstructions ? [_c("div", {
    staticClass: "flex --baseline"
  }, [_c("div", {
    staticClass: "text-smaller",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.inboundDelivery.deliveryInstructions) || "No instruction")
    }
  })])] : [_c(VTextarea, {
    ref: "inputDeliveryInstruction",
    staticClass: "delivery-instructions-textarea",
    attrs: {
      rows: "3",
      filled: "",
      placeholder: "Write your instructions here",
      "hide-details": "auto"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        $event.preventDefault();
        return _vm.updateDeliveryInstructions.apply(null, arguments);
      }
    },
    model: {
      value: _vm.newDeliveryInstructions,
      callback: function callback($$v) {
        _vm.newDeliveryInstructions = $$v;
      },
      expression: "newDeliveryInstructions"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Save for next purchases"
    },
    model: {
      value: _vm.isDeliveryInstructionsAsDefaultForUserAdress,
      callback: function callback($$v) {
        _vm.isDeliveryInstructionsAsDefaultForUserAdress = $$v;
      },
      expression: "isDeliveryInstructionsAsDefaultForUserAdress"
    }
  }), _c("div", {
    staticClass: "flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click() {
        _vm.isEditingDeliveryInstructions = false;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.updateDeliveryInstructions();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save delivery instructions ")], 1)], 1)]], 2)])]), _vm.inboundDelivery.importer.id > 0 || _vm.canEditImporter ? _c("div", [_c("div", [_c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-people-arrows"
  }), _vm._v(" Wholesaler "), _vm.canEditImporter && !_vm.isEditingImporter ? _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    on: {
      click: _vm.startEditImporter
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [!_vm.isEditingImporter ? [_vm.inboundDelivery.importer && _vm.inboundDelivery.importer.id > 0 ? _c("div", [_vm._v(" " + _vm._s(_vm.inboundDelivery.importer.name) + " ")]) : _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v("No wholesaler")])] : [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.importersForSelector,
      "item-value": "id",
      "item-text": "name",
      "return-object": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.importerSelectorSelected,
      callback: function callback($$v) {
        _vm.importerSelectorSelected = $$v;
      },
      expression: "importerSelectorSelected"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click() {
        _vm.isEditingImporter = false;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: !_vm.importerSelectorSelected
    },
    on: {
      click: _vm.saveChangeImporter
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save wholesaler ")], 1)], 1)]], 2)])]) : _vm._e()]), _c("div", {
    staticClass: "--one-column"
  }, [_c("div", {
    staticClass: "flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: "",
      loading: _vm.isExportingXlsFreight
    },
    on: {
      click: function click($event) {
        return _vm.exportXlsFreight();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-file-excel mr-1",
    attrs: {
      size: "10"
    }
  }), _vm._v(" XLS Freight ")], 1)], 1)]), _c("div", {
    staticClass: "withBeforeSeparator"
  }, [((_vm$inboundDelivery$c2 = _vm.inboundDelivery.consultant) === null || _vm$inboundDelivery$c2 === void 0 ? void 0 : _vm$inboundDelivery$c2.id_user) > 0 ? _c("div", [_vm._m(7), _c("div", [_c("div", [_vm._v(_vm._s(_vm.inboundDelivery.consultant.fullname))])])]) : _vm._e(), ((_vm$inboundDelivery$s = _vm.inboundDelivery.salesman) === null || _vm$inboundDelivery$s === void 0 ? void 0 : _vm$inboundDelivery$s.id_user) > 0 ? _c("div", [_vm._m(8), _c("div", [_vm._v(" " + _vm._s(_vm.inboundDelivery.salesman.fullname) + " ")])]) : _vm._e(), ((_vm$inboundDelivery$c3 = _vm.inboundDelivery.creator) === null || _vm$inboundDelivery$c3 === void 0 ? void 0 : _vm$inboundDelivery$c3.id_user) != _vm.inboundDelivery.user.id_user ? _c("div", [_vm._m(9), _c("div", [_vm._v(" " + _vm._s(_vm.inboundDelivery.creator.fullname) + " ")])]) : _vm._e()])]), _c("div", {
    staticClass: "inbound-delivery-maincontent-summary",
    attrs: {
      id: "inbound-delivery-summary"
    }
  }, [_c("h3", [_vm._v(" Order dispatch summary "), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("span", {
    staticClass: "nb-items"
  }, [_vm._v(" : " + _vm._s(_vm.nbBottles) + " Bottle" + _vm._s(_vm.nbBottles > 1 ? "s" : "") + " ")]) : _vm._e()]), _c("div", [_c("div", {
    staticClass: "inbound-delivery-maincontent-summary-items mt-4"
  }, _vm._l(_vm.inboundDelivery.items, function (item) {
    return _c("div", {
      key: item.orderItem.id_item,
      staticClass: "item-row",
      class: [_vm.isCollapsed && "collapse"]
    }, [_c("div", {
      staticClass: "item-row-img"
    }, [item.orderItem.wine && item.orderItem.wine.image && item.orderItem.wine.image.length ? _c("img", {
      attrs: {
        src: item.orderItem.wine.image,
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("@/assets/images/_temp/wine_default_primary_img.png"),
        alt: ""
      }
    })]), _c("div", {
      staticClass: "item-row-informations"
    }, [_c("div", {
      staticClass: "item-row-winename"
    }, [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.wineDetails(item.orderItem.wine.id_wine)
      }
    }, [_c("wineNaming", {
      attrs: {
        wineNamingData: item.orderItem.wine.naming_data,
        isPrefixWinery: true,
        isSuffixBottling: true,
        isSuffixType: true
      }
    })], 1), _c("div", {
      staticClass: "item-row-provenance"
    }, [_vm._v(" From " + _vm._s(item.warehouse.name) + ", " + _vm._s(item.orderItem.wine.accountancy_code) + " ")])], 1), _c("div", {
      staticClass: "item-row-lineprices"
    }, [_c("div", {
      staticClass: "item-row-quantity"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Qty")]), _c("div", {
      staticClass: "item-row-lineprices-maindata"
    }, [_vm._v(_vm._s(item.quantity) + " b.")])])]), _c("div", {
      staticClass: "item-row-unitprice"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Unit price")]), _c("div", {
      staticStyle: {
        display: "flex"
      }
    }, [_c("div", {
      staticClass: "item-row-lineprices-maindata text-nowrap"
    }, [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(item.unitPriceCurrency), " ").concat(_vm.getSymbolCurrency())) + " / bottle ")])])])]), _c("div", {
      staticClass: "item-row-totalprice"
    }, [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Total")]), _c("div", {
      staticClass: "item-row-lineprices-maindata text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.amountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency()) + " ")]), _c("div", {
      staticClass: "text-tax-info"
    }, [_vm.isConcernedByVat ? [_vm._v(" " + _vm._s(" incl. sales tax") + " ")] : [[_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]]], 2)])]), item.unitPriceCurrency != item.orderItem.unit_price_currency ? _c("div", {
      staticClass: "item-row-bypass-prices"
    }, [_c(VAlert, {
      staticClass: "bypass-message --small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" The initial unit price (" + _vm._s("".concat(_vm.formatPrice(item.orderItem.unit_price_currency), " ").concat(_vm.getSymbolCurrency())) + ") differs from the actual unit price. ")])], 1) : _vm._e()])]);
  }), 0), _vm.inboundDelivery.length > 4 ? _c("div", {
    staticClass: "items-collapsis"
  }, [_vm.isCollapsed ? _c("div", {
    staticClass: "overlay"
  }) : _vm._e(), _vm.isCollapsed ? _c(VAlert, {
    staticClass: "--small",
    attrs: {
      dense: "",
      outlined: "",
      type: "info",
      text: ""
    }
  }, [_vm._v(" " + _vm._s("Click below to show the ".concat(_vm.inboundDelivery.length - 4, " other reference").concat(_vm.inboundDelivery.length - 4 > 1 ? "s" : "", " of this order dispatch")) + " ")]) : _vm._e(), _c(VBtn, {
    on: {
      click: function click($event) {
        return _vm.collapse();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v(_vm._s(_vm.isCollapsed ? "mdi-chevron-down" : "mdi-chevron-up"))])], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "inbound-delivery-maincontent-summary-linetotal"
  })]), _c("div", {
    staticClass: "--one-column"
  }, [_c(VDivider, {
    staticClass: "my-5"
  }), _vm.inboundDelivery.amountShippingCurrency > 0 ? _c("div", {
    staticClass: "inbound-delivery-maincontent-summary-linetotal-shipping text-right mb-1"
  }, [_vm._v(" Shipping "), _c("span", [_vm._v(" + "), [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.inboundDelivery.amountShippingCurrency / _vm.nbBottles)) + " ")], _vm._v(" " + _vm._s(_vm.getSymbolCurrency()) + " / bottle ")], 2), _c("span", [_vm._v(" : " + _vm._s(_vm.formatPrice(_vm.inboundDelivery.amountShippingCurrency || 0)) + " " + _vm._s(_vm.getSymbolCurrency()) + " ")])]) : _vm._e(), _c("div", {
    staticClass: "inbound-delivery-maincontent-data-total"
  }, [_c("div", [_vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.inboundDelivery.totalAmountCurrencyIncludeShipping)) + " " + _vm._s(_vm.getSymbolCurrency()) + " * ")]), _c("div", {
    staticClass: "text-tax-info"
  }, [_vm.isConcernedByVat ? [_vm._v(" " + _vm._s(" incl. sales tax") + " ")] : [[_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]]], 2)])], 1)])])]), ((_vm$inboundDelivery = _vm.inboundDelivery) === null || _vm$inboundDelivery === void 0 || (_vm$inboundDelivery = _vm$inboundDelivery.items) === null || _vm$inboundDelivery === void 0 ? void 0 : _vm$inboundDelivery.length) != 0 ? _c("div", {
    staticClass: "inbound-delivery-bottom-content container-centered small"
  }, [_vm._m(10)]) : _vm._e(), ((_vm$inboundDelivery2 = _vm.inboundDelivery) === null || _vm$inboundDelivery2 === void 0 || (_vm$inboundDelivery2 = _vm$inboundDelivery2.items) === null || _vm$inboundDelivery2 === void 0 ? void 0 : _vm$inboundDelivery2.length) > 0 ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("Exit")])], 1) : _vm._e(), _vm.inboundDelivery.items.length ? _c("InboundDeliveryAttachedFilesDrawer", {
    ref: "InboundDeliveryAttachedFilesDrawerRef",
    attrs: {
      id: _vm.inboundDelivery.id,
      items: _vm.inboundDelivery.items,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm._e(), _vm.sendMailModalShown ? _c("SendMailModal", {
    ref: "SendMailModal",
    attrs: {
      inboundDelivery: _vm.inboundDelivery,
      globalOrderFiles: _vm.attachedFiles,
      relatedWineFiles: _vm.attachedWineFiles,
      relatedWineryFiles: _vm.attachedWineryFiles
    },
    on: {
      closed: _vm.closeSendMailModal
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-battery-three-quarters"
  }), _vm._v(" Status ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "far fa-calendar-alt"
  }), _vm._v(" Dates ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-user"
  }), _vm._v(" Customer ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-phone"
  }), _vm._v(" Customer contacts ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "far fa-clock"
  }), _vm._v(" Payment terms ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-dolly"
  }), _vm._v(" Pickup ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck"
  }), _vm._v(" Carrier ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fa fa-handshake"
  }), _vm._v(" Corporate ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fa fa-handshake"
  }), _vm._v(" Salesperson ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fa fa-user-edit"
  }), _vm._v(" Creator ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "inbound-delivery-bottom-content-incoterms"
  }, [_c("div", [_c("div", {
    staticClass: "text-incoterms"
  }, [_vm._v(" *Sold in delivered duty paid incoterm. Delivered duty paid is a delivery agreement whereby the seller assumes all of the responsibility, risk, and costs associated with transporting goods until the buyer receives or transfers them at the destination port. This agreement includes paying for shipping costs, export and import duties, insurance, and any other expenses incurred during shipping to an agreed-upon location in the buyer's country. ")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };